module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-900italic.f20b423a.woff";